
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';

export interface GetRevenueOfCategoryDetailRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly categoryId: number;
        readonly startDate: string;
        readonly endDate: string;
        readonly objectType?: "SERVICE" | "PRODUCT";
    }
}

export interface GetRevenueOfCategoryDetailResponse  {
    readonly totalRevenue?: number;
    readonly totalQuantity?: number;
    readonly salonBranchId?: number;
}

export const getRevenueOfCategoryDetail = httpUtil.createHttpRequestMeta<
    GetRevenueOfCategoryDetailRequest,
    PaginationResponse<GetRevenueOfCategoryDetailResponse>
>({
    baseUrl: env.orgServer,
    path: '/revenues/category-detail',
    method: 'GET',
    authentication: 'bearer'
});
